function getCornerPosition(libMap, map) {
    const mapBounds = map.getBounds() instanceof libMap.LatLngBounds ? map.getBounds() : new libMap.LatLngBounds();
    const ne = mapBounds.getNorthEast();
    const sw = mapBounds.getSouthWest();

    return {
        topLeft: new libMap.LatLng(ne.lat(), sw.lng()),
        topRight: new libMap.LatLng(ne.lat(), ne.lng()),
        bottomRight: new libMap.LatLng(sw.lat(), ne.lng()),
        bottomLeft: new libMap.LatLng(sw.lat(), sw.lng()),
    };
}

module.exports = {
    getCornerPosition,
};
